import { IDictionary } from '@bimser/core';
import { IFont, IPropertyField, MultiLanguageText } from '../../../entities/common';
import { ILabelBaseProperties } from '../entities/ILabelBaseProperties';
import { filterFields, getCultureEnumMembers } from '../helper';
import VisualControl from './VisualControl';
import { JSX } from 'react';

export default class LabelBase extends VisualControl {
	text: MultiLanguageText;
	font: IFont;
	height: number;
	lineHeight: number;

	constructor() {
		super();

		this.caption.visible = false;
		this.font = {
			bold: true,
			color: '#4a90e2',
			family: 'Source Sans Pro, sans-serif',
			italic: false,
			size: '12',
			strikethrough: false,
			underline: false
		};
		this.height = null;
		this.lineHeight = null;
	}

	__getMLClassPath() {
		return [...super.__getMLClassPath(), 'text'];
	}

	initialize() {
		super.initialize();
		this.text = new MultiLanguageText(
			(text: string, culture: string, existCultures: string[]) => {
				this.__onChangeMLTextValue(text, 'text', culture, existCultures);
			}
		);
	}

	__loadProperties(data: ILabelBaseProperties) {
		super.__loadProperties(data);

		if (data.text) {
			this.text.setData(data.text);
		}

		this.__proxyChanged.font = data.font;
		this.__proxyChanged.height = data.height;
		this.__proxyChanged.lineHeight = data.lineHeight;
	}

	__getPropertyFields(): IPropertyField[] {
		return [
			...filterFields(super.__getPropertyFields(), ['enabled', 'clientEnabled']),
			{
				name: 'text',
				type: 'object',
				items: getCultureEnumMembers(true),
				common: true
			},
			{
				name: 'height',
				type: 'number'
			},
			{
				name: 'lineHeight',
				type: 'number'
			}
		];
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData(),
			text: this.text.getData(),
			font: this.font,
			height: this.height,
			lineHeight: this.lineHeight
		};
	}

	__render(children?: React.ReactNode): JSX.Element {
		return super.__render(children);
	}
}
